const dataWuModalTriggers = document.querySelectorAll('[data-wu-modal-trigger]');
dataWuModalTriggers.forEach((triggerEl) => {
    console.log("triggers");
    const triggerModalName = triggerEl.getAttribute('data-wu-modal-trigger');
    if(triggerModalName){
        triggerEl.addEventListener('click', (e) => {
            const dataWuModalContents = document.querySelector(`[data-wu-modal-content=${triggerModalName}]`);
            dataWuModalContents.classList.toggle("d-flex");
            dataWuModalContents.classList.toggle("d-none");
            if (dataWuModalContents.classList.contains('d-flex')){
                window.performance.mark('QuantumMetricTransitionStart');
              } else {
                window.performance.mark('QuantumMetricTransitionStop');
              }
        })
    }
});